/* eslint-disable react-hooks/exhaustive-deps */
import {useContext} from 'react'
import useFilters from '../../../../hook/useFilters'
import useApi from '../../../../services/useApi'
import {getTimeZone} from '../../../../utils/date'
import {ProjectDetailsContext} from '../../context'


const useGetTimeSheetData = () => {
  const Api = useApi()
  const {projectId} = useContext(ProjectDetailsContext)
  const initialFilters = {
    project_id: projectId,
    start_date: true,
    end_date: true,
    sort_by: 'customer_name/-1',
    timezone: getTimeZone(),
    report_type: 'individual_project_timesheet_report',
  }

  const {filters, onSearch, onSortingChange, onDateChange, searchValue, setMultipleFilters} =
    useFilters(initialFilters, {
      sortType: 'number',
    })

  const {
    data: response,
    isFetching,
    refetch,
  } = Api.useGetQuery(
    `/agile/projects/timesheet`,
    {
      queryId: 'project-report-time-sheet',
      filters: filters,
    },
    {
      enabled: projectId !== '',
    }
  )

  const onProjectChange = (id: any) => {
    setMultipleFilters({
      project_id: id,
    })
  }

  return {
    timeSheetData: response?.data?.customers || [],
    timeSheetMeta: response?.data?.meta,
    filtersData: response?.data?.filters || [],
    filters,
    isLoading: isFetching,
    onSortingChange,
    onSearch,
    searchValue,
    onProjectChange,
    onDateChange,
    refetch,
  }
}

export default useGetTimeSheetData
